import React from "react";

export const CoffeeIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M33.4433 31.5438H34.9652C36.6387 31.5438 38 30.1969 38 28.541C38 26.8853 36.639 25.5385 34.9652 25.5385H33.6446V23.8396H16.6518V30.017C16.6518 32.5101 18.2059 34.643 20.407 35.5217H16C16.0003 36.3382 16.6689 37.0001 17.4946 37.0001H33.4539C34.2789 37.0001 34.9478 36.3378 34.9478 35.5217H29.8794C31.6181 34.83 32.9559 33.3601 33.4433 31.5438ZM33.6446 27.3308H34.9652C35.6396 27.3308 36.1882 27.8737 36.1882 28.541C36.1882 29.2083 35.6396 29.7512 34.9652 29.7512H33.6446V27.3308Z"
        fill="white"
      />
      <path
        d="M22.5318 19.5309C24.4852 22.514 22.5647 23.2335 22.5647 23.2335C22.5647 23.2335 26.0014 21.9546 24.5047 19.0932C23.008 16.2321 23.4844 14.9529 23.4844 14.9529C23.4844 14.9529 20.2224 16.0035 22.5318 19.5309Z"
        fill="white"
      />
      <path
        d="M26.1623 18.6575C28.1348 22.4241 26.1982 23.2331 26.1982 23.2331C26.1982 23.2331 29.9958 21.6526 28.3419 18.1167C26.688 14.5809 27.214 13 27.214 13C27.214 13 23.8289 14.2027 26.1623 18.6575Z"
        fill="white"
      />
    </svg>
  );
};

export const ChildcareIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M24.1948 20.528C26.011 20.5259 27.4847 19.0648 27.4847 17.2639C27.4847 15.4577 26.0112 13.9959 24.1948 14C22.3762 13.9956 20.903 15.4577 20.9043 17.2639C20.903 19.065 22.3759 20.5262 24.1948 20.528Z"
        fill="white"
      />
      <path
        d="M33.2185 36.7646C33.208 36.7461 33.1936 36.7316 33.182 36.7139L33.1875 36.7108C33.1875 36.7108 30.9227 33.6248 27.6813 29.2476L27.6427 27.3583V24.8414L30.3782 27.5546C31.4754 28.7092 33.1485 27.1662 32.0023 26.0342L27.5502 21.6036C27.1844 21.2479 26.7657 21.0308 26.1494 21.0261H24.1937H22.1983C21.5744 21.0311 21.1832 21.2547 20.8242 21.6036L16.4245 25.9817C15.2175 27.1808 16.8464 28.7092 18.0499 27.5151L20.706 24.8539V27.3583V28.8272V28.8275C20.0027 34.6865 19.5163 38.9001 19.5163 38.9001H19.5226C19.5213 38.9209 19.5163 38.9404 19.5163 38.9617C19.5163 39.5342 19.9841 39.998 20.5611 39.998C21.061 39.998 21.4779 39.6491 21.5804 39.1835H21.5817L22.2974 36.314C22.9635 33.6921 23.4836 31.4406 23.4836 31.4406L25.135 31.2662C25.134 31.2682 25.1329 31.2711 25.1329 31.2711L26.0296 32.1608C26.0296 32.1608 27.6129 33.878 29.504 35.8424L31.5223 37.9569C31.523 37.9577 31.5238 37.9584 31.5244 37.9592L31.5317 37.9668L31.5322 37.9665C31.8532 38.3219 32.3894 38.422 32.8241 38.1774C33.3272 37.8953 33.5028 37.2627 33.2185 36.7646Z"
        fill="white"
      />
      <path
        d="M35.3902 35.5398C36.8316 35.5398 38.0001 34.3805 38.0001 32.9504C38.0001 31.5202 36.8316 30.3609 35.3902 30.3609C33.9488 30.3609 32.7803 31.5202 32.7803 32.9504C32.7803 34.3805 33.9488 35.5398 35.3902 35.5398Z"
        fill="white"
      />
    </svg>
  );
};

export const HealthIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M36.2815 30.8112H33.0463V27.6321C33.0463 27.1818 32.6754 26.8164 32.2177 26.8164H30.6276C30.1698 26.8164 29.7982 27.1818 29.7982 27.6321V30.8115H26.5635C26.1055 30.8115 25.7344 31.1763 25.7344 31.6272V33.1897C25.7344 33.6403 26.1055 34.0051 26.5635 34.0051H29.7982V37.1843C29.7982 37.6348 30.1698 37.9999 30.6276 37.9999H32.2177C32.6754 37.9999 33.0463 37.6348 33.0463 37.1843V34.0048H36.2812C36.7389 34.0048 37.1109 33.64 37.1109 33.1894V31.6269C37.1112 31.1761 36.7392 30.8112 36.2815 30.8112Z"
        fill="white"
      />
      <path
        d="M24.9257 33.1895V31.627C24.9257 30.7388 25.661 30.0157 26.5643 30.0157H28.9892V27.6321C28.9892 26.7442 29.7246 26.0211 30.6281 26.0211H32.2181C33.121 26.0211 33.8561 26.7442 33.8561 27.6321V30.0157H33.9829L35.9418 28.09C38.522 25.5536 38.522 21.4402 35.9418 18.9027C33.3607 16.3656 29.1764 16.3659 26.5958 18.9027L25.8777 19.6091L25.1585 18.9027C22.578 16.3659 18.3936 16.3656 15.8128 18.9027C13.2318 21.44 13.2318 25.5533 15.8123 28.09L25.878 37.9842L28.9892 34.9246V34.8005H26.5643C25.6608 34.8005 24.9257 34.0776 24.9257 33.1895Z"
        fill="white"
      />
    </svg>
  );
};

export const FitnessIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M13.2425 32.747C12.9192 33.0685 12.9192 33.5918 13.2425 33.9151L15.203 35.8738L14.2106 36.8671L16.1338 38.7894L17.1262 37.7979L19.0849 39.7575C19.4082 40.0808 19.9306 40.0808 20.253 39.7575L21.6902 38.3212L14.6788 31.3088L13.2425 32.747Z"
        fill="white"
      />
      <path
        d="M38.7573 20.0849L36.7967 18.1243L37.7891 17.1328L35.866 15.2087L34.8736 16.2021L32.9149 14.2425C32.5916 13.9192 32.0692 13.9192 31.7468 14.2425L30.3096 15.6788L37.321 22.6893L38.7573 21.253C39.0806 20.9296 39.0806 20.4073 38.7573 20.0849Z"
        fill="white"
      />
      <path
        d="M28.5525 16.2684C28.2301 15.945 27.7068 15.945 27.3844 16.2684L24.779 18.8746L28.4057 22.5014L21.4999 29.4062L17.8732 25.7795L15.2679 28.3858C14.9446 28.7072 14.9446 29.2305 15.2679 29.5539L23.4465 37.7325C23.7698 38.0558 24.2922 38.0558 24.6146 37.7325L27.2208 35.1262L23.5932 31.4995L30.499 24.5946L34.1257 28.2213L36.732 25.615C37.0544 25.2936 37.0544 24.7703 36.732 24.4469L28.5525 16.2684Z"
        fill="white"
      />
    </svg>
  );
};

export const GroceryIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M34.4075 22.1414C33.9526 22.6021 33.2322 22.6021 32.7772 22.1414L27.6967 16.9965C27.2417 16.5358 27.2417 15.8063 27.6967 15.3455C28.1517 14.8848 28.872 14.8848 29.327 15.3455L34.3696 20.452C34.8625 20.9511 34.8625 21.6806 34.4075 22.1414Z"
        fill="white"
      />
      <path
        d="M37.0993 19.7993H36.4547C36.1893 19.7993 35.9998 20.0681 36.0756 20.2984C36.4547 21.2583 36.2273 22.4101 35.469 23.178C34.9761 23.6772 34.2936 23.9843 33.5733 23.9843C32.8529 23.9843 32.1704 23.7155 31.6775 23.178L28.796 20.26C28.4927 19.9529 28.1136 19.7993 27.6965 19.7993H23.2226C22.8056 19.7993 22.4264 19.9529 22.1231 20.26L19.2796 23.1396C18.8246 23.6004 18.2179 23.9459 17.5734 23.9843C16.7772 24.0611 16.0189 23.7539 15.4502 23.2164C14.9573 22.7173 14.654 22.0262 14.654 21.2967C14.654 20.9511 14.7298 20.644 14.8436 20.3368C14.9573 20.0681 14.7677 19.7993 14.5023 19.7993H13.7441C12.7962 19.7993 12 20.6056 12 21.5655C12 22.5637 12.7962 23.3316 13.7441 23.3316H14.3128C14.5023 23.3316 14.6919 23.4852 14.7298 23.6771L16.6635 36.4241C16.7014 36.7696 17.0047 37 17.3459 37H33.6491C33.9903 37 34.2557 36.7312 34.3315 36.4241L36.2652 23.6771C36.3031 23.4852 36.4547 23.3316 36.6822 23.3316H37.2509C38.2746 23.3316 39.0708 22.4485 38.995 21.4119C38.8433 20.4904 38.0092 19.7993 37.0993 19.7993ZM20.7582 32.4695C20.7582 32.8534 20.4549 33.1222 20.1137 33.1222C19.7345 33.1222 19.4691 32.815 19.4691 32.4695V25.5585C19.4691 25.1745 19.7724 24.9058 20.1137 24.9058C20.4928 24.9058 20.7582 25.2129 20.7582 25.5585V32.4695ZM24.3222 32.4695C24.3222 32.8534 24.0188 33.1222 23.6776 33.1222C23.2985 33.1222 23.0331 32.815 23.0331 32.4695V25.5585C23.0331 25.1745 23.3364 24.9058 23.6776 24.9058C24.0568 24.9058 24.3222 25.2129 24.3222 25.5585V32.4695ZM27.924 32.4695C27.924 32.8534 27.6207 33.1222 27.2795 33.1222C26.9003 33.1222 26.6349 32.815 26.6349 32.4695V25.5585C26.6349 25.1745 26.9382 24.9058 27.2795 24.9058C27.6586 24.9058 27.924 25.2129 27.924 25.5585V32.4695ZM31.488 32.4695C31.488 32.8534 31.1847 33.1222 30.8434 33.1222C30.4643 33.1222 30.1989 32.815 30.1989 32.4695V25.5585C30.1989 25.1745 30.5022 24.9058 30.8434 24.9058C31.2226 24.9058 31.488 25.2129 31.488 25.5585V32.4695Z"
        fill="white"
      />
      <path
        d="M16.5121 22.1414C16.9671 22.6021 17.6875 22.6021 18.1424 22.1414L23.185 17.0349C23.64 16.5742 23.64 15.8447 23.185 15.3839C22.7301 14.9232 22.0097 14.9232 21.5547 15.3839L16.5121 20.4904C16.0572 20.9511 16.0572 21.6806 16.5121 22.1414Z"
        fill="white"
      />
    </svg>
  );
};

export const PetIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M22.6588 21.6735C22.785 21.6735 22.9111 21.6735 23.0625 21.6485C24.5261 21.3741 25.4345 19.6776 25.0812 17.8564C24.728 16.0352 23.2644 14.7628 21.8009 15.0372C21.0691 15.162 20.4635 15.636 20.085 16.3845C19.7065 17.083 19.6055 17.9562 19.7569 18.8294C20.085 20.476 21.3214 21.6735 22.6588 21.6735Z"
        fill="white"
      />
      <path
        d="M19.1763 21.7982C18.8988 20.9999 18.3688 20.3014 17.7128 19.8772C17.0315 19.4531 16.2997 19.3284 15.6184 19.5529C14.2557 20.0269 13.6249 21.7982 14.2305 23.4947C14.5081 24.2931 15.038 24.9916 15.6941 25.4157C16.1483 25.7151 16.6277 25.8648 17.0819 25.8648C17.309 25.8648 17.5614 25.8149 17.7885 25.7401C19.1259 25.2661 19.7567 23.4947 19.1763 21.7982Z"
        fill="white"
      />
      <path
        d="M28.9419 21.6485C29.0681 21.6735 29.1943 21.6735 29.3457 21.6735C30.6578 21.6735 31.9195 20.476 32.2223 18.8294C32.399 17.9562 32.2728 17.083 31.8943 16.3845C31.5158 15.661 30.9102 15.1869 30.1784 15.0372C28.7148 14.7628 27.2513 16.0352 26.898 17.8564C26.57 19.6776 27.4784 21.3741 28.9419 21.6485Z"
        fill="white"
      />
      <path
        d="M36.3605 19.5778C34.9978 19.1287 33.4081 20.1266 32.8277 21.8231C32.2474 23.5196 32.853 25.266 34.2408 25.74C34.4679 25.8148 34.695 25.8647 34.9474 25.8647C35.4016 25.8647 35.881 25.715 36.3352 25.4157C36.9913 24.9915 37.496 24.3179 37.7988 23.4947C38.3539 21.7982 37.7231 20.0268 36.3605 19.5778Z"
        fill="white"
      />
      <path
        d="M29.421 23.9937C27.4275 22.397 24.5508 22.397 22.5321 23.9937C20.1097 25.9147 17.334 28.7089 17.334 31.3035C17.334 37.5655 34.6191 37.5655 34.6191 31.3035C34.6444 28.7089 31.8434 25.9147 29.421 23.9937Z"
        fill="white"
      />
    </svg>
  );
};

export const ActivitiesIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M26 24.9392L33.9313 17.0086C31.6636 15.0062 28.8275 13.9942 25.9842 14C25.8265 16.7836 24.7613 19.5182 22.7939 21.7326L26 24.9392Z"
        fill="white"
      />
      <path
        d="M21.7321 22.7943C19.5176 24.7622 16.7825 25.8262 14 25.9846C13.9942 28.8278 15.0056 31.664 17.0074 33.9317L24.9387 26.001L21.7321 22.7943Z"
        fill="white"
      />
      <path
        d="M34.9919 33.931C36.6308 32.0735 37.5967 29.8333 37.8917 27.5206C35.5306 27.6959 33.218 28.6121 31.3271 30.2663L34.9919 33.931Z"
        fill="white"
      />
      <path
        d="M30.2661 31.3279C28.6114 33.2187 27.6958 35.5308 27.5205 37.8919C29.8326 37.5974 32.0728 36.6316 33.9303 34.9926L30.2661 31.3279Z"
        fill="white"
      />
      <path
        d="M25.9996 27.0615L18.0684 34.9921C20.3366 36.9945 23.1728 38.0065 26.0148 38.0007C26.1737 35.2171 27.2383 32.4826 29.2063 30.2681L25.9996 27.0615Z"
        fill="white"
      />
      <path
        d="M30.2672 29.2064C32.4817 27.2385 35.2168 26.1745 37.9998 26.0155C38.0056 23.1729 36.9936 20.3368 34.9918 18.0691L27.0605 25.9998L30.2672 29.2064Z"
        fill="white"
      />
      <path
        d="M17.0077 18.0696C15.3687 19.9271 14.4034 22.1673 14.1084 24.48C16.4696 24.3047 18.7816 23.3885 20.673 21.7344L17.0077 18.0696Z"
        fill="white"
      />
      <path
        d="M21.7344 20.6727C23.3886 18.7819 24.3047 16.4698 24.4801 14.1087C22.1674 14.4032 19.9272 15.369 18.0703 17.008L21.7344 20.6727Z"
        fill="white"
      />
    </svg>
  );
};

export const ShopIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M35.1391 22.2943H26.1392C25.4936 22.2943 24.924 22.8702 24.886 23.5228L24.3164 34.8482C24.3164 35.1554 24.3924 35.4241 24.6202 35.6545C24.8101 35.8848 25.1139 36 25.4177 36H35.8986C36.2024 36 36.4682 35.8848 36.6961 35.6545C36.886 35.4241 36.9999 35.1554 36.9999 34.8482L36.4303 23.5228C36.3543 22.8318 35.7847 22.2943 35.1391 22.2943ZM34.1518 26.3254C34.1518 28.2833 32.5948 29.8574 30.6581 29.8574C28.7214 29.8574 27.1645 28.2833 27.1645 26.3254V25.3656C27.1645 24.9817 27.4683 24.6746 27.848 24.6746C28.2278 24.6746 28.5316 24.9817 28.5316 25.3656V26.3254C28.5316 27.5155 29.4809 28.4369 30.6202 28.4369C31.7974 28.4369 32.7088 27.4771 32.7088 26.3254V25.3656C32.7088 24.9817 33.0126 24.6746 33.3923 24.6746C33.772 24.6746 34.0758 24.9817 34.0758 25.3656V26.3254H34.1518Z"
        fill="white"
      />
      <path
        d="M29.5569 20.8739V19.6838C29.5569 19.0311 29.0252 18.4937 28.3797 18.4937H17.1772C16.5316 18.4937 16 19.0311 16 19.6838V34.8099C16 35.4626 16.5316 36 17.1772 36H23.1772C22.9873 35.6161 22.9114 35.2322 22.9493 34.7715L23.481 23.4461C23.5569 22.0256 24.7341 20.8739 26.1392 20.8739H29.5569Z"
        fill="white"
      />
      <path
        d="M26.3669 20.6819H19.9492V18.2249C19.9492 16.4589 21.3922 15 23.1391 15C24.8859 15 26.3289 16.4589 26.3289 18.2249V20.6819H26.3669ZM21.0885 19.5302H25.1897V18.2249C25.1897 17.0731 24.2783 16.1517 23.1391 16.1517C21.9998 16.1517 21.0885 17.0731 21.0885 18.2249V19.5302Z"
        fill="white"
      />
    </svg>
  );
};

export const BarIcon = ({ size = 52, color = "#C2D6F1" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" fill={color} />
      <path
        d="M32.2297 21.5882V24.9916C32.2297 26.8319 30.7703 28.3445 28.9647 28.3445C28.7668 28.3445 28.5936 28.3193 28.4205 28.2941C26.8375 28.0168 25.6996 26.605 25.6996 24.9159V21.5882H19.5159V24.3109H17.7597C15.682 24.3109 14 26.0252 14 28.1428V31.0924C14 33.21 15.682 34.9243 17.7597 34.9243H19.5159V35.9832C19.5159 37.0924 20.4064 38 21.4947 38H33.0212C34.1095 38 35 37.0924 35 35.9832V21.6134H32.2297V21.5882ZM17.735 32.1512C17.1661 32.1512 16.6961 31.6722 16.6961 31.0924V28.1176C16.6961 27.5378 17.1661 27.0588 17.735 27.0588H19.4912V32.1512H17.735Z"
        fill="white"
      />
      <path
        d="M27.5548 21.3866V24.916C27.5548 25.6218 28.0248 26.3025 28.7174 26.4034C29.5831 26.5546 30.3746 25.8487 30.3746 24.9916V21.3866C30.3746 20.4286 31.1167 19.6723 32.0566 19.6723H35.0001V18.437C35.0001 17.2521 34.1591 16.2437 33.046 16.042C32.8481 16.0168 32.6997 15.8655 32.6008 15.7143C32.205 14.958 31.4135 14.4286 30.4983 14.4286C30.152 14.4286 29.8304 14.5042 29.5336 14.6303C29.2863 14.7311 29.0142 14.7059 28.8163 14.5546C28.3463 14.2017 27.7774 14 27.1343 14C26.5407 14 25.9718 14.2017 25.5266 14.5294C25.3534 14.6555 25.1061 14.6807 24.9082 14.605C24.6361 14.5042 24.364 14.4286 24.0672 14.4286C23.152 14.4286 22.3605 14.958 21.9647 15.7143C21.8658 15.8908 21.7174 16.0168 21.5195 16.042C20.4064 16.2437 19.5654 17.2269 19.5654 18.437V19.6723H25.9471C26.8128 19.6723 27.5548 20.4286 27.5548 21.3866Z"
        fill="white"
      />
    </svg>
  );
};

export const MapPinIcon = ({ size = 10, color = "#CDCDCD" }) => {
  return (
    <svg width={size} height={size * 1.4} viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.206896 6.57789C1 9.28643 3.7931 12.6281 5 14C6 12.8744 8.96552 9.42714 9.7931 6.61307C9.82759 6.47236 9.86207 6.33166 9.89655 6.15578V6.08543C9.96552 5.69849 10 5.38191 10 5.1005C10 2.28643 7.75862 0 5 0C2.24138 0 0 2.28643 0 5.1005C0 5.38191 0.0344825 5.73367 0.103448 6.08543C0.103448 6.22613 0.137931 6.40201 0.206896 6.57789ZM5 2.74372C6.24138 2.74372 7.24138 3.76382 7.24138 5.03015C7.24138 6.29648 6.24138 7.31658 5 7.31658C3.75862 7.31658 2.75862 6.29648 2.75862 5.03015C2.75862 3.76382 3.75862 2.74372 5 2.74372Z"
        fill={color}
      />
    </svg>
  );
};
